import { render } from "./Addon.vue?vue&type=template&id=5b24e88a&scoped=true"
import script from "./Addon.vue?vue&type=script&lang=js"
export * from "./Addon.vue?vue&type=script&lang=js"

import "./Addon.vue?vue&type=style&index=0&id=5b24e88a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b24e88a"]])

export default __exports__